
module.exports.fieldTypes = {
    salesSummary: "salesSummary",
    salesByVenueCode: "salesByVenueCode",
    salesByDispatchType: "salesByDispatchType",
    salesByPaymentMethod: "salesByPaymentMethod",
    salesByMenuCategory: "salesByMenuCategory",
    salesByCovers: "salesByCovers",
    saleDiscounts: "saleDiscounts",
    saleCharges: "saleCharges",
    saleRefunds: "saleRefunds",
    saleCancellations: "saleCancellations",
    saleVats: "saleVats",
    floatSession: "floatSession",
    floatSessionJournal: "floatSessionJournal"
}